import React, { useEffect, useRef, useState } from "react";

export const Preloader = ({ ready }) => {
  const [pct, setPct] = useState(0);
  const [phase, setPhase] = useState("loading"); // loading -> exit -> gone
  const readyRef = useRef(ready);
  readyRef.current = ready;

  useEffect(() => {
    const id = setInterval(() => {
      setPct((prev) => {
        const cap = readyRef.current ? 100 : 88;
        return Math.min(prev + 4 + Math.random() * 7, cap);
      });
    }, 55);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (pct >= 100 && phase === "loading") {
      const t = setTimeout(() => setPhase("exit"), 300);
      return () => clearTimeout(t);
    }
  }, [pct, phase]);

  useEffect(() => {
    if (phase === "exit") {
      const t = setTimeout(() => setPhase("gone"), 850);
      return () => clearTimeout(t);
    }
  }, [phase]);

  if (phase === "gone") return null;

  return (
    <div
      data-testid="preloader"
      className={`fixed inset-0 z-50 flex flex-col items-center justify-center bg-[#111111] transition-opacity duration-700 ease-out ${
        phase === "exit" ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >
      <span className="hcc-serif text-2xl tracking-[0.35em] text-[#C7A45D] mb-10 pl-2">
        HCC
      </span>
      <div className="w-52 h-px bg-white/10 overflow-hidden">
        <div
          data-testid="preloader-progress-line"
          className="h-full bg-[#C7A45D] transition-[width] duration-150 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
      <p
        data-testid="preloader-text"
        className="mt-8 text-[11px] tracking-[0.45em] uppercase text-[#F7F1E7]/50 font-light"
      >
        Curating the collection
      </p>
    </div>
  );
};
